"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlAttributes = void 0;
exports.htmlAttributes = [
    'abbr',
    'accept',
    'acceptCharset',
    'accessKey',
    'action',
    'allowFullScreen',
    'allowTransparency',
    'alt',
    'async',
    'autoComplete',
    'autoFocus',
    'autoPlay',
    'cellPadding',
    'cellSpacing',
    'challenge',
    'charset',
    'checked',
    'cite',
    'class',
    'className',
    'cols',
    'colSpan',
    'command',
    'content',
    'contentEditable',
    'contextMenu',
    'controls',
    'coords',
    'crossOrigin',
    'data',
    'dateTime',
    'default',
    'defer',
    'dir',
    'disabled',
    'download',
    'draggable',
    'dropzone',
    'encType',
    'for',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'frameBorder',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hrefLang',
    'htmlFor',
    'httpEquiv',
    'icon',
    'id',
    'inputMode',
    'isMap',
    'itemId',
    'itemProp',
    'itemRef',
    'itemScope',
    'itemType',
    'kind',
    'label',
    'lang',
    'list',
    'loop',
    'manifest',
    'max',
    'maxLength',
    'media',
    'mediaGroup',
    'method',
    'min',
    'minLength',
    'multiple',
    'muted',
    'name',
    'noValidate',
    'open',
    'optimum',
    'pattern',
    'ping',
    'placeholder',
    'poster',
    'preload',
    'radioGroup',
    'readOnly',
    'rel',
    'required',
    'role',
    'rows',
    'rowSpan',
    'sandbox',
    'scope',
    'scoped',
    'scrolling',
    'seamless',
    'selected',
    'shape',
    'size',
    'sizes',
    'sortable',
    'span',
    'spellCheck',
    'src',
    'srcDoc',
    'srcSet',
    'start',
    'step',
    'style',
    'tabIndex',
    'target',
    'title',
    'translate',
    'type',
    'typeMustMatch',
    'useMap',
    'value',
    'width',
    'wmode',
    'wrapp',
];
